<template>
  <router-view/>
</template>
<script>
export default {
  beforeRouteUpdate(to, from, next) {
    if(to.name == 'venda-unidades-medida'){
      next({ name: 'ven-unidade-medida-list' })
    }else{
      next()
    }
  },
  created() {
    if(this.$route.name == 'venda-unidades-medida'){
      this.$router.push({ name: 'ven-unidade-medida-list' })
    }
  }
}
</script>